import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CourseCard from "./CourseCard"; // Für die Anzeige der Kurse
import ICONS from '../config/icon'; // Icons für Kurse

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);

  const searchQuery = searchParams.get("query"); // Hol den Suchbegriff aus der URL

  useEffect(() => {
    // Lade alle Kurse vom Backend
    fetch('/get_courses.php')
      .then((response) => {
        if (!response.ok) {
          throw new Error("Fehler beim Laden der Kursdaten");
        }
        return response.json();
      })
      .then((data) => {
        setCourses(data);

        // Führe die Suche basierend auf der Query aus
        if (searchQuery) {
          const searchPattern = searchQuery
            .toLowerCase()
            .trim()
            .replace(/\s+/g, ".*")
            .split(" ")
            .map((word) => `(?=.*${word})`)
            .join("");

          const regex = new RegExp(searchPattern, "i");

          const results = data.filter((course) => {
            return (
              regex.test(course.title.toLowerCase()) ||
              course.description.some((desc) => regex.test(desc.toLowerCase())) ||
              regex.test(course.instructor.toLowerCase()) ||
              regex.test(course.category.toLowerCase())
            );
          });

          setFilteredCourses(results);
        }
      })
      .catch((error) => console.error("Fehler beim Laden der Kurse:", error));
  }, [searchQuery]);

  return (
    <div className="container mx-auto px-6 py-10">
      <h1 className="text-3xl font-bold mb-6">
        Ergebnisse für: <span className="text-brand">"{searchQuery}"</span>
      </h1>

      {filteredCourses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {filteredCourses.map((course) => (
            <CourseCard
              key={course.id}
              course={course}
              icon={ICONS[course.icon] || ICONS.default}
            />
          ))}
        </div>
      ) : (
        <p className="text-gray-600 mt-4">
          Es wurden keine Kurse gefunden, die zu deiner Suche passen.
        </p>
      )}
    </div>
  );
};

export default SearchResults;